import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from "../../../components/RequestDefinition";

const getNextManufactureOrderNumberRequest: RequestExample = {
    title: {
        verb: 'GET',
        endpointUrl: '/api/manufacture-orders/next-number',
    },
    curl:
        `curl --location \\
--request GET '<YOUR SERVER>/api/manufacture-orders/next-number' \\
--header 'Authorization: Bearer <TOKEN>'
`,
};

const getNextManufactureOrderNumberResponse: Json = {
    title: 'RESPONSE',
    json: {
        title: 'THE NEXT ORDER NUMBER OBJECT',
        json: {
            "orderNumber": "1005"
        },
    },
};

const data: RequestDefinitionData = {
    id: 'get-next-manufacture-order-number',
    title: 'Get the next manufacture order number',
    description: 'Returns the next available manufacture order number based on the system\'s auto-numbering settings. '
        + 'Note: calling this endpoint immediately consumes the order number — the number is incremented and '
        + 'reserved regardless of whether a manufacture order is subsequently created. '
        + 'Returns a 400 error if manufacture order auto-numbering is not enabled; in that case, enable it in the Module '
        + 'Options or supply the order number manually when creating a manufacture order.',
    endpoint: {
        verb: 'GET',
        path: '/manufacture-orders/next-number',
        tooltip: 'Get the next manufacture order number',
    },
    attributes: [],
    requestObject: getNextManufactureOrderNumberRequest,
    responseObject: getNextManufactureOrderNumberResponse,
};

export default data;
